import { Injectable } from "@angular/core";
import { LocalhostKeys } from "../enum/localhost-keys";
import { ICredentials } from "../interfaces/auth.interface";
import { IGenericResponse } from "../interfaces/reponse.interface";
//DOCUMENTATION: https://www.linkedin.com/pulse/angular-14-firebase-authentication-tutorial-attia-imed
import * as Util from '../helpers/utils';
import { HttpClient } from "@angular/common/http";

import { from, Observable, of, throwError } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { UsersService } from './users.service';
import { PermissionsService } from './permissions.service';
import { SessionStorageKeys } from '../enum/session-storage-keys';

@Injectable({
    providedIn: 'root'
})
export class SessionService {

    userName: string = '';
    private sessionMonitor: any;
    private isRefreshing = false;

    constructor(
        private usersSvc: UsersService,
        private permissionsService: PermissionsService,
        private http: HttpClient
    ) { }

    private handleSessionExpired() {
      sessionStorage.removeItem(SessionStorageKeys.SESSION);
      window.location.href = '/auth/login';
    }


    refreshSession(): Observable<string> {
      const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);
      if (!authInfoString) {
        this.handleSessionExpired();
        return throwError(() => new Error('No hay sesión en almacenamiento.'));
      }

      const authInfo = JSON.parse(authInfoString);
      const refreshToken = authInfo?.auth?.refreshToken;

      if (!refreshToken) {
        this.handleSessionExpired();
        return throwError(() => new Error('No hay refreshToken válido.'));
      }

      return this.usersSvc.refresh(refreshToken).pipe(
        switchMap(refreshResult => {
          if (!refreshResult.success) {
            this.handleSessionExpired();
            return throwError(() => new Error('Refresh token inválido'));
          }

          authInfo.loginAt = new Date().toISOString();
          authInfo.auth = refreshResult.data.auth;
          sessionStorage.setItem(SessionStorageKeys.SESSION, JSON.stringify(authInfo));
          return from(this.permissionsService.reauthenticateFirebase()).pipe(
            switchMap(() => {
              return of(authInfo.auth.token);
            })
          );
        }),


        catchError(error => {
          console.error('Error al hacer refresh:', error);
          this.handleSessionExpired();
          return throwError(() => error);
        })
      );
    }

    // private handleSessionExpired() {
    //   sessionStorage.removeItem(SessionStorageKeys.SESSION);
    //   // aquí podrías redirigir al login
    // }

    async login(credentials: ICredentials): Promise<IGenericResponse> {
        return new Promise(async (resolve) => {
            /* signInWithEmailAndPassword(this.auth, credentials.username, credentials.password)
                .then((loginResult) => {
                    const user = loginResult.user as any;
                    const sessionData = {
                        key: user.uid,
                        email: user.email,
                        emailVerified: user.emailVerified,
                        displayName: user.displayName,
                        auth: user.stsTokenManager
                    }

                    sessionStorage.setItem(SessionStorageKeys.SESSION, JSON.stringify(sessionData));
                    resolve({ success: true });
                }).catch((error) => {
                    resolve({ success: false, data: error });
                }); */
            const loginResult = await this.usersSvc.login(credentials).toPromise();
            console.log('loginResult:', loginResult);
            if (loginResult.success) {
                const user = loginResult.data.user as any;
                const sessionData = {
                    key: user.id,
                    user: user,
                    loginAt: (new Date()).toISOString(),
                    loggedSinceAt: (new Date()).toISOString(),
                    auth: loginResult.data.auth,
                    permissions: loginResult.data.user.permissions
                }
                sessionStorage.setItem(SessionStorageKeys.SESSION, JSON.stringify(sessionData));
                // this.startSessionMonitor();
                resolve({ success: true });
            } else {
                resolve({ success: false, data: loginResult.data });
            }
        });
    }


    setUserName(userName: string) {
        this.userName = userName;
        localStorage.setItem(LocalhostKeys.USERNAME, userName);
    }

    getUserName() {
        const userName = localStorage.getItem(LocalhostKeys.USERNAME);
        if (userName) {
            return userName;
        }
        return '';
    }

    getCurrentPlant(){
        const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);
        let authInfo: any = null;
        if (authInfoString) {
            authInfo = JSON.parse(authInfoString);
            return authInfo.user.plant;
        }
        return { id: 1 };// Dallas
    }

    getPlants() {
        const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);
        let authInfo: any = null;
        if (authInfoString) {
            authInfo = JSON.parse(authInfoString);
            return authInfo.user.plants;
        }
    }

    resetPassword(data: any): Observable<IGenericResponse>  {
        const url: string = `${Util.getUrl('/session')}/reset-password-request`;
        return this.http.post<IGenericResponse>(url, data);
    }

    verificarToken(token: string): Observable<IGenericResponse> {
        const url: string = `${Util.getUrl('/session')}/reset-password-verify/${token}`;
        return this.http.get<IGenericResponse>(url);
    }

    submitPassword(data: any): Observable<IGenericResponse>  {
        const url: string = `${Util.getUrl('/session')}/reset-password`;
        return this.http.post<IGenericResponse>(url, data);
    }


    // startSessionMonitor(): void {
    //     // Evitar múltiples intervalos
    //     if (this.sessionMonitor) {
    //         return;
    //     }

    //     this.sessionMonitor = setInterval(() => {
    //         this.validateSession();
    //     }, 60000);
    // }


    // private async validateSession(): Promise<void> {
    //     if (this.isRefreshing) {
    //         return;
    //     }

    //     const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);

    //     if (!authInfoString) {
    //         this.handleSessionExpired();
    //         return;
    //     }

    //     const authInfo = JSON.parse(authInfoString);

    //     const loginAt = new Date(authInfo.loginAt).getTime();
    //     const now = Date.now();
    //     const expiryMs = authInfo?.auth?.expiryMilliseconds;

    //     if (!expiryMs) {
    //         this.handleSessionExpired();
    //         return;
    //     }

    //     const elapsed = now - loginAt;
    //     const remaining = expiryMs - elapsed;

    //     // Si ya expiró
    //     if (remaining <= 0) {
    //         console.warn('Sesión expirada.');
    //         this.handleSessionExpired();
    //         return;
    //     }

    //     // Si faltan menos de 60 segundos → refrescar
    //     if (remaining < 60000) {
    //         console.log('Refrescando sesión...');
    //         this.isRefreshing = true;

    //         try {
    //             await this.refreshSession();
    //         } catch (error) {
    //             console.error('Error refrescando sesión:', error);
    //             this.handleSessionExpired();
    //         } finally {
    //             this.isRefreshing = false;
    //         }
    //     }
    // }

    // stopSessionMonitor(): void {
    //     if (this.sessionMonitor) {
    //         clearInterval(this.sessionMonitor);
    //         this.sessionMonitor = null;
    //     }
    // }

    logout(): void {
        // this.stopSessionMonitor();
        sessionStorage.removeItem(SessionStorageKeys.SESSION);
        window.location.href = '/auth/login';
    }

}
